"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = Separator;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Separator({
  color = 'gray600',
  direction = 'vertical',
  testId
}) {
  const as = direction === 'horizontal' ? 'hr' : undefined;
  const role = direction === 'vertical' ? 'separator' : undefined;
  return /*#__PURE__*/_react.default.createElement(_styled.StyledBase, {
    as: as,
    color: color,
    "data-testid": testId,
    direction: direction,
    role: role
  });
}